import { TbCategory2 } from "react-icons/tb";
import { Pie, PieChart, Sector } from "recharts";

const renderActiveShape = ({
   cx,
   cy,
   midAngle,
   innerRadius,
   outerRadius,
   startAngle,
   endAngle,
   cornerRadius,
   fill,
   payload,
   percent,
   value,
}) => {
   return (
      <g>
         <Sector
            cx={cx}
            cy={cy}
            innerRadius={innerRadius * 1.15}
            outerRadius={outerRadius}
            cornerRadius={cornerRadius / 2}
            startAngle={startAngle}
            endAngle={endAngle}
            fill={fill}
         />
      </g>
   );
};

const mapKeys = {
   activeLicenses: {
      name: 'Ativas',
      fill: `var(--activeLicensesColor)`,
   },
   blockedLicenses: {
      name: 'Bloqueadas',
      fill: `var(--blockedLicensesColor)`,
   },
   noAssociatedLicenses: {
      name: 'Sem dispositivo',
      fill: `var(--noDeviceLicensesColor)`,
   },
   overdueLicenses: {
      name: 'Em atraso',
      fill: `var(--expiredLicensesColor)`,
   },
   upcomingDueLicenses: {
      name: 'Vencendo',
      fill: `var(--upcomingDueLicensesColor)`,
   },
};

export function LicensesByStatus({ licensesStats, ...props }) {

   const stats = licensesStats ? Object.entries(licensesStats)?.map(([key, quantity]) => {
      return {
         name: mapKeys[key].name,
         total: quantity,
         fill: mapKeys[key].fill,
      };
   }) : [];

   return (
      <div className="w-full h-fit border! border-(--borderColor)! rounded-(--borderRadius)! **:text-(--textColor) box-border! shadow-(--box-shadow) bg-(--containerBackgroundColor)">
         <div className="w-full flex flex-row items-center gap-2 border-b! border-(--borderColor)! px-5! py-4! box-border! font-bold! text-[0.9rem]!">
            <TbCategory2 size={19} />
            <span className="font-bold! leading-[0.1]!">
               Licenças por status
            </span>
         </div>
         <div className="flex flex-row items-center gap-9 w-full px-7! py-7! pr-9! box-border!">
            <PieChart
               style={{
                  width: '185px',
                  height: '185px'
               }}
               className="aspect-square"
               responsive
            >
               <Pie
                  activeShape={(args) => renderActiveShape({ ...args })}
                  data={stats}
                  innerRadius="64%"
                  outerRadius="100%"
                  cornerRadius={2}
                  fill="#8884d8"
                  paddingAngle={0}
                  dataKey="total"
                  stroke=''
                  isAnimationActive={true}
               />
            </PieChart>
            <div className="flex-1">
               <div className="w-full box-border!">
                  <table className="table-auto w-full">
                     <thead>
                        <tr>
                           <th></th>
                           <th></th>
                        </tr>
                     </thead>
                     <tbody>
                        {stats.map((item, index) => (
                           <tr key={index} className="group/table-row">
                              <td className="box-border! py-2.5!">
                                 <div className="flex flex-row items-center gap-2" style={{ '--statColor': item.fill }}>
                                    <span className="size-3 bg-(--statColor) rounded-full"></span>
                                    <span>
                                       {item.name}
                                    </span>
                                 </div>
                              </td>
                              <td className="box-border! py-2.5! text-right!">
                                 <div className="flex flex-row items-center justify-end gap-1">
                                    <span className="font-semibold!">{item.total}</span>
                                    <span className="opacity-60">
                                       ({((item.total / stats.reduce((acc, curr) => acc + curr.total, 0)) * 100).toFixed(2)}%)
                                    </span>
                                 </div>
                              </td>
                           </tr>
                        ))}
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      </div>
   );
}